export default __webpack_public_path__ + "static/media/auth-background.412bfb96.webp";